import React, {useState} from 'react'

function isElectron() {
  // Renderer process
  if (typeof window !== 'undefined' && typeof window.process === 'object' && window.process.type === 'renderer') {
    return true;
  }

  // Main process
  if (typeof process !== 'undefined' && typeof process?.versions === 'object' && !!process?.versions.electron) {
    return true;
  }

  // Detect the user agent when the `nodeIntegration` option is set to true
  if (typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0) {
    return true;
  }

  return false;
}

const DeviceNameContext = React.createContext()
DeviceNameContext.displayName = 'DeviceNameContext'

function DeviceNameProvider(props) {
  const [deviceName, setDeviceName] = useState(false);

  React.useEffect(() => {
    if (isElectron()) {
      window.api?.receive("deviceNameFromMain", (data) => {
        console.log('Received deviceName='+data+' in deviceNameFromMain from Main process');
        if (data) {
            setDeviceName(data);
        }
      });
      // Send a message to the main process
      window.api?.send("asyncToMain", "deviceName");
    }
    }, [])

  const value = React.useMemo(() => ({ deviceName }), [
    deviceName,
  ])
  return <DeviceNameContext.Provider value={value} {...props} />
}

function useDeviceName() {
  const context = React.useContext(DeviceNameContext)
  if (context === undefined) {
    throw new Error('useDeviceName must be used within a DeviceNameProvider');
  }
  return context
}

export { DeviceNameProvider, useDeviceName }